<div class="ub ub-ac ub-pc ub-ver assistant-div" :style="style" ref="el" v-if="showAssistant">
  <a-dropdown placement="top" >
    <div class="ub ub-ac ub-pc last">
      <img src="@/assets/images/assistant.png"  style="width:86px;height:75px;cursor: pointer;"/>
    </div>
    <template #overlay>
      <a-menu >
        <!-- <a-menu-item>
          <div class="ub ub-ac ub-pc item" @click="goZero">限时0元</div>
        </a-menu-item> -->
        <!-- <a-menu-item>
          <div class="ub ub-ac ub-pc item" @click="goVideo">新手课堂</div>
        </a-menu-item>
        <a-menu-item>
          <div class="ub ub-ac ub-pc item" @click="displayWX">
            <span>微信服务号</span>
          </div>
        </a-menu-item>
        <a-menu-item>
          <div class="ub ub-ac ub-pc item" @click="concatKefu">联系客服</div>
        </a-menu-item> -->
        <a-menu-item>
          <div class="ub ub-ac ub-pc item" @click="goVersion">版本更新</div>
        </a-menu-item>
       
       
        <a-menu-item>
          <div class="ub ub-ac ub-pc item">
            <TheFeedback :hideIcon="true">我要吐槽</TheFeedback>
          </div>
        </a-menu-item>
        <a-menu-item>
          <div class="ub ub-ac ub-pc item" @click="closeDialog">关闭悬浮</div>
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</div>
<div class="ub ub-ver tips2 ub-as ub-pc theme-bg-color" v-if="showTips">
  <div class="jiantou"></div>
  <div class="ub ub-ac ub-ps fw title">小提示</div>
  <div class="ub ub-ac ub-ps fw sub-title">您可以在【帮助中心】找回您的小助手</div>
  <div class="ub ub-ac ub-pb footers">
    <div class="ub ub-ac ub-ps no-tips" @click="noAlert">不再提醒</div>
    <div class="ub ub-ac ub-pc btn" @click="close">知道了</div>
  </div>
</div>